/** @jsx jsx */
import PropTypes from 'prop-types'
//import React from 'react'
import { Container, Flex, Grid, jsx, useThemeUI } from 'theme-ui'
import { useState } from 'react'
import { CardSquare } from '../CardSquare'
import { InfoCard } from '../InfoCard'
import Heading from '~/components/IntlComponents/Heading'
// import KitList from '~/components/Kit/List'
//import ProductList from '~/components/Product/List'
import { getTextColor } from '~/utils/get-collection-colors'
//import { experiments, useExperiment } from '~/hooks/utils/use-experiment'

const infoCards = [
  {
    title: 'COMMUNITY LOVE',
    description:
      'Did you know? GOODLES is committed to giving away at least 1% of all the products we sell to organizations that address food insecurity.',
    icon: 3,
    iconColor: '#6E5BE8',
  },
  {
    title: 'WINNER WINNER NOODLE DINNER',
    description:
      'We are the first boxed mac and cheese ever to receive Clean Label certification, and we are so excited to lead the way with clean ingredients.',
    icon: 2,
    iconColor: '#FFDD00',
  },
]

const insertInfoCards = (arr, index, newItem) => [
  ...arr.slice(0, index),
  newItem,
  ...arr.slice(index),
]

const CollectionList = ({ collection, currentCollection }) => {
  const { colorMode } = useThemeUI()
  const [openAtc, setOpenAtc] = useState('')
  const { title, products, slug /* kits */ } = collection

  const infoCard1 = (
    <InfoCard
      {...infoCards[0]}
      key={'info-card-1' + infoCards[0].title + title}
      forwardSx={{
        '& h2': {
          color: 'brilliantRose',
        },
        '& span': {
          color: infoCards?.[0]?.iconColor || 'black',
        },
      }}
    />
  )

  const infoCard2 = (
    <InfoCard
      {...infoCards[1]}
      key={'info-card-2' + infoCards[1].title + title}
      forwardSx={{
        backgroundColor: 'governorBay',
        '& h2': {
          color: '#45eeff',
        },
        '& span': {
          color: infoCards?.[1]?.iconColor || 'white',
        },
      }}
    />
  )

  const productsToDisplay = products ?? [] /* || kits */



  const productMap = productsToDisplay.map((product, index) => (
      <CardSquare
        key={product?.slug + '-' + slug + '-' + index}
        product={product}
        setOpenAtc={setOpenAtc}
        openAtc={openAtc}
        collectionName={slug}
      />
  ))

  // Insert Info card only if the its an individual collection with enough products
  // Otherwise on Shop-all insert only on Mac Collection
  const insertInfoCard =
    (!currentCollection && slug === 'mac-and-cheese') || !!currentCollection

  const insetFirstInfoCart =
    productsToDisplay?.length > 3 && insertInfoCard
      ? insertInfoCards(productMap, 3, infoCard1)
      : insertInfoCards(productMap, 3)

  const productWithInfoCards =
    insetFirstInfoCart?.length > 7 && insertInfoCard
      ? insertInfoCards(insetFirstInfoCart, 8, infoCard2)
      : insetFirstInfoCart

  return (
    <Container
      sx={{
        maxWidth: '1440px',
        paddingTop: ['12px', null, '90px'],
      }}
    >
      <Flex
        sx={{
          alignItems: 'center',
          flexDirection: ['column', 'row'],
          justifyContent: 'space-between',
          padding: ['16px 24px', null, '32px 0'],
          width: '100%',
        }}
      >
        <Heading
          variant="text.h2"
          sx={{
            lineHeight: '1em',
            paddingRight: [null, '5rem'],
            textAlign: ['center', 'left'],
            textTransform: 'uppercase',
            fontSize: '2em',
            marginBottom: ['8px', 0, null],
            color: getTextColor(collection, collection.slug),
          }}
        >
          {title}
        </Heading>
      </Flex>

      {productsToDisplay && (
        <Grid
          columns={[2, 3]}
          gap={['15px', '62px']}
          p={['0 0 2rem', '0 0 6.25rem 0']}
        >
          {productWithInfoCards}
        </Grid>
      )}
    </Container>
  )
}

CollectionList.propTypes = {
  collection: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    slug: PropTypes.string,
    description: PropTypes.shape({}),
    products: PropTypes.arrayOf(
      PropTypes.shape({
        sku: PropTypes.string,
        slug: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        price: PropTypes.number,
        mainImage: PropTypes.shape({
          title: PropTypes.string,
          url: PropTypes.string,
        }),
        images: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string,
          }),
        ),
        comingSoon: PropTypes.bool,
      }),
    ),
    kits: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        slug: PropTypes.string,
        price: PropTypes.number,
        regularPrice: PropTypes.number,
        products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        soldOut: PropTypes.bool,
        comingSoon: PropTypes.bool,
        description: PropTypes.shape({}),
        images: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string,
          }),
        ),
      }),
    ),
    mainImage: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
}

export default CollectionList
